import { saveAs } from 'file-saver';
import { takeLatest, select, cancel } from 'redux-saga/effects';

import { authTokenSelector } from '../../auth/selectors';
import { attachmentUrlResolver } from '../../../constants/chat';

import previewImage from '../helpers/previewImage';
import chatConsts from '../constants';
import actions from '../actions';

function* downloadAttachmentWorker({ dispatch }, action) {
  const state = yield select();

  const authToken = authTokenSelector(state);

  const {
    id,
    fileName: name,
    type,
    channelId,
    isPreview,
    parentMsgId,
  } = action.payload;
  const src = attachmentUrlResolver(authToken, id);
  const credentials = {
    channelId,
    id,
    parentMsgId,
  };

  const clearDownload = () =>
    dispatch(actions.removeDownloadAttachment(credentials));
  const updateDownload = params =>
    dispatch(
      actions.updateAttachmentDownloadStatus({
        ...credentials,
        ...params,
      }),
    );

  if (type.includes('pdf') && isPreview) {
    window.open(src);
    yield cancel();
  }

  const xhr = new XMLHttpRequest();
  xhr.open('GET', src);
  xhr.responseType = 'blob';

  xhr.onprogress = e =>
    updateDownload({
      id,
      channelId,
      name,
      progress: Math.round((e.loaded / e.total) * 100),
      isPreview,
      cancel: () => {
        xhr.abort();
        clearDownload();
      },
    });

  // eslint-disable-next-line consistent-return
  xhr.onload = e => {
    const blob = new Blob([e.target.response], { type });
    clearDownload();

    if (!isPreview) return saveAs(blob, name);

    // Preview functionality
    if (type.includes('image')) return previewImage(blob, dispatch);
  };

  xhr.send();
}

export default function* downloadAttachmentSaga(...args) {
  yield takeLatest(
    [chatConsts.DOWNLOAD_ATTACHMENT],
    downloadAttachmentWorker,
    ...args,
  );
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/downloadAttachment.js